import React from 'react';
import { Fragment } from 'react';
import { ProfileShape } from '../shapes';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import FollowDisplayName from './follow_display_name';

export default class recommendedUserToFollow extends React.Component {

  static propTypes = {
    recommendedUserToFollow: ProfileShape,
    onFollow: PropTypes.func,
    onUnFollow: PropTypes.func,
  }

  render() {
    return (
      <div className='row follow-row'>
        <div className='col-sm-6'>
          <FollowDisplayName user={ this.props.recommendedUserToFollow } />
          <div className='item-meta'>
            { this.props.recommendedUserToFollow.get('headline') }
          </div>
        </div>
        <div className='col-sm-3 item-meta'>{ pluralize('tack', this.props.recommendedUserToFollow.get('tacksCount'), true) }</div>
        <div className='col-sm-3 item-meta'>{ this.renderFollowAction() }</div>
      </div>
    );
  }

  renderFollowAction() {
    if (this.props.recommendedUserToFollow.get('followedAt')) {
      return (
        <Fragment>
          <button className='btn btn-outline-secondary' data-primary-cta onClick={ () => this.onUnFollow() }>Unfollow</button>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <button className='btn btn-outline-secondary' data-primary-cta onClick={ () => this.onFollow() }>Follow</button>
        </Fragment>
      );
    }
  }

  onFollow() {
    this.props.onFollow(this.props.recommendedUserToFollow.get('slug'));
  }

  onUnFollow() {
    this.props.onUnFollow(this.props.recommendedUserToFollow.get('slug'));
  }
}



// WEBPACK FOOTER //
// ./src/components/recommended_user_to_follow.jsx